<template>
  <div>
    <Hero
      title="<strong>Vagas</strong><br/>Assim é a <strong>InBrands</strong>"
      image="banner-vagas.png"
      :searchBox="true"
      layout="md"
      class="darker"
    />

    <Brands />

    <div class="job row">

      <div class="col-12">
        <SpinnerLoader v-if="!opportunity" />
        <div v-else>
          <div class="row py-4">
            <div class="col-11 col-lg-9 mx-auto"></div>
          </div>

          <div class="row pb-4">
            <div class="col-11 col-lg-9 mx-auto">
              <div class="d-flex flex-column flex-md-row align-items-center justify-content-between">
                <div>
                  <h2 class="opportunity-title">
                    <wheelchair-accessibility-icon
                      class="mr-1 text-blue-ml"
                      v-if="opportunity.pcd"
                    />
                    {{ opportunity.title }}
                  </h2>

                  <h3 class="opportunity-level">
                    Nível {{ opportunity.level }}
                  </h3>

                  <h3 class="h6 mt-4">
                    <span class="font-serif-bold" v-if="opportunity.acting_mode">{{
                      opportunity.acting_mode
                    }}</span>
                    <span
                      class="font-serif-bold"
                      v-if="opportunity.address && opportunity.address.city"
                    >
                      {{
                        " - " +
                          this.$helpers.toTitle(opportunity.address.city)
                      }}
                      {{ opportunity.address.state && " - " + opportunity.address.state.abbr }} <br />
                    </span>

                    <span
                      class="font-italic font-weight-normal"
                      v-if="opportunity.address"
                    >
                      <span
                        v-if="opportunity.address.street"
                        class="text-capitalize"
                        >{{ opportunity.address.street.toLowerCase() }}</span
                      >
                      <span v-if="opportunity.address.number"
                        >, {{ opportunity.address.number }}</span
                      >
                      <span
                        v-if="opportunity.address.neighborhood"
                        class="text-capitalize"
                      >
                        - {{ opportunity.address.neighborhood.toLowerCase() }}</span
                      >
                    </span>
                  </h3>
                </div>

                <a
                  v-if="subscriptionStep == 'lead'"
                  :href="redirectSubscription"
                  class="btn-subscription"
                  :class="[
                    opportunity.status_id != 1  ? 'font-weight-bold btn-red disabled' : 'btn-blue-ml',
                  ]"
                >
                 {{ opportunity.status_id != 1 ? 'Inscrições Encerradas' : 'Continuar Inscrição' }}
                </a>
                <a
                  v-else
                  :href="redirectSubscription"
                  class="btn-subscription"
                  :class="[
                    enrolled || opportunity.status_id != 1 ? 'font-weight-bold btn-red disabled' : 'btn-blue-ml',
                  ]"
                >
                  {{ enrolled ? "Você Já Está Inscrito" : opportunity.status_id != 1 ? "Inscrições Encerradas" : "Inscrever-Se" }}
                </a>
              </div>
            </div>
          </div>

          <div class="row pb-4">
            <div class="col-11 col-lg-9 mx-auto">
              <hr />
            </div>
          </div>

          <div class="row vem-pro-inbrands">
            <div class="col-11 col-lg-9 mx-auto">
              <h6>Vem pra InBrands!</h6>
              <p>A Inbrands tem em seu portfólio, marcas de moda e lifestyle icônicas e desejadas. O nosso universo é plural e cheio de energia. </p>
              <p>Buscamos pessoas com senso de urgência, ousadia, otimismo, persistência e que se entusiasmem com seu próprio inconformismo. Se você se identifica com o nosso jeito de ser, aqui é o seu lugar!</p>
              <br />

            </div>
          </div>

          <div class="row pb-4 responsability" v-if="opportunity.responsability">
            <div class="col-11 col-lg-9 mx-auto">
              <h4 class="opportunity-description-title">
                Responsabilidades
              </h4>

              <div class="">
                <div
                  class="responsability opportunity-description-text"
                  v-html="opportunity.responsability"
                ></div>
              </div>
            </div>
          </div>

          <div class="row pb-4" v-if="opportunity.requirement">
            <div class="col-11 col-lg-9 mx-auto">
              <h4 class="opportunity-description-title">
                Requisitos
              </h4>

              <div class="">
                <div class="requirement opportunity-description-text" v-html="opportunity.requirement"></div>
              </div>
            </div>
          </div>

          <div class="row pb-4" v-if="opportunity.work_environment">
            <div class="col-11 col-lg-9 mx-auto">
              <h4 class="opportunity-description-title">
                Ambiente de trabalho
              </h4>

              <div class="">
                <div
                  class="work-environment opportunity-description-text"
                  v-html="opportunity.work_environment"
                ></div>
              </div>
            </div>
          </div>

          <div class="row pb-4" v-if="opportunity.benefits.length">
            <div class="col-11 col-lg-9 mx-auto">
              <h4 class="opportunity-description-title">
                Benefícios
              </h4>

              <div class="ml-md-5">
                <div class="boxes-beneficios">
                  <span class="box opportunity-description-text" v-for="benefit in opportunity.benefits" :key="benefit.id">
                    <span class="benefits" :class="benefit.icon"></span>
                    <p>{{ benefit.name }}</p>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="row pb-4" v-if="opportunity.other_benefit">
            <div class="col-11 col-lg-9 mx-auto">
              <h4 class="opportunity-description-title">
                Observações/Benefícios Adicionais
              </h4>

              <div class="">
                <div class="other_benefit opportunity-description-text" v-html="opportunity.other_benefit"></div>
              </div>
            </div>
          </div>

          <div class="row pb-2">
            <div class="col-11 col-lg-9 mx-auto">
              <hr />
            </div>
          </div>

          <div class="row pb-5">
            <div class="col-11 col-lg-9 mx-auto">
              <div
                class="
                  d-flex
                  flex-column-reverse flex-md-row
                  align-items-center
                  justify-content-between
                "
              >
                <router-link
                  to="/vagas"
                  class="btn btn-transparent text-muted mt-4 mt-md-0"
                  >VER MAIS VAGAS DISPONÎVEIS</router-link
                >
                <a
                  v-if="subscriptionStep == 'lead'"
                  :href="redirectSubscription"
                  class="btn-subscription"
                  :class="[
                    opportunity.status_id != 1  ? 'font-weight-bold btn-red disabled' : 'btn-blue-ml',
                  ]"
                >
                 {{ opportunity.status_id != 1 ? 'Inscrições Encerradas' : 'Continuar Inscrição' }}
                </a>
                <a
                  v-else
                  :href="redirectSubscription"
                  class="btn-subscription"
                  :class="[
                    enrolled || opportunity.status_id != 1 ? 'font-weight-bold btn-red disabled' : 'btn-blue-ml',
                  ]"
                >
                  {{ enrolled ? "Você Já Está Inscrito" : opportunity.status_id != 1 ? "Inscrições Encerradas" : "Inscrever-Se" }}
                </a>
              </div>
               <p class="text-right text-orange-ml" v-if="subscriptionStep == 'lead' && opportunity.status_id != 1">
                Você não concluiu a inscrição até a data de expiração, mas a empresa poderá entrar em contato.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WheelchairAccessibilityIcon from "vue-material-design-icons/WheelchairAccessibility.vue";
import SpinnerLoader from "ninenine-white-label/src/components/Loader/SpinnerLoader";
import Hero from "@/components/media/Hero.vue";
import Brands from "@/views/home/components/Brands.vue";

export default {
  name: "Job",
  data() {
    return {
      opportunity: null,
      notFound: false,
    };
  },
  computed: {
    subscriptionStep() {
      const id = this.opportunity.id;
      const findSubscription = this.$store.state.opportunities.subscriptions.find(
        (subs) => subs.opportunityId == id
      );
      if (findSubscription) {
        return findSubscription.step;
      }
      return '';
    },

    enrolled() {
      const regex = /\/(\d+)/; // Captura números após "/"
       const match = regex.exec(this.opportunity.links.subscription); // Encontra a primeira ocorrência
       const id = match ? Number(match[1]) : null
      return this.$store.state.opportunities.subscriptions.find(
        (subs) => subs.opportunityId == id
      )
        ? true
        : false;
    },

    redirectSubscription() {
      if (this.opportunity.ninenine_apply === true) {
        if (process.env.VUE_APP_LOCAL_ENV !== 'production' ) {
          return `https://subscriptions.staging.99jobs.com/${this.opportunity.id}?callbackOriginUrl=${window.location.href}`;
        }
        return `https://subscriptions.99jobs.com/${this.opportunity.id}?callbackOriginUrl=${window.location.href}`;
      }
      return '/vagas/' + this.opportunity.slug + '/inscricao';
    }
  },
  components: {
    WheelchairAccessibilityIcon,
    SpinnerLoader,
    Hero,
    Brands
  },
  created() {
    this.getOpportunity();
  },
  methods: {
    getOpportunity() {
      // Como ML pode ser Labs também, então fazemos uma dupla consulta e temos um counter para não haver loop infinito
      let counter = 0;

      const get = () => {
        this.$store
          .dispatch("opportunities/getOpportunity", this.$route.params.id)
          .then((opportunity) => {
            if (opportunity) {
              this.opportunity = opportunity;
              this.notFound = false;
              this.pageTitle = this.$helpers.toTitle(this.opportunity.title);
              this.$emit("updateHead");
            }  else {
              this.notFound = true;
            }
          });
      };

      get();
    },
  },
};
</script>

<style lang="scss" scoped>
.job{
  padding-top: 50px;
}

.opportunity-title{
  font-size: 36px;
  font-weight: 700;
  line-height: 36px;
  letter-spacing: 0em;
  text-align: left;
  color: #000000;
  margin-bottom: 15px;

  @media (max-width: 600px){
    font-size: 28px;
  }
}

.opportunity-level{
  font-size: 24px;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0em;
  text-align: left;
  color: #939598;

  @media (max-width: 600px){
    font-size: 20px;
    line-height: 1.6;
  }
}

h1 {
  display: flex;
  align-items: center;
  text-align: center;
  font-size: 62px;
  &:before,
  &:after {
    content: "";
    width: auto;
    height: 4px;
    background: theme-color("blue-ml");
    flex-grow: 1;
    border-radius: 30px;
  }
  &:before {
    margin-right: 60px;
    @include media-breakpoint-down(md) {
      margin-right: 15px;
    }
  }
  &:after {
    margin-left: 60px;
    @include media-breakpoint-down(md) {
      margin-left: 15px;
    }
  }
}

/deep/ .benefits {
  @include media-breakpoint-down(md) {
    width: 30px;
    height: 30px;
  }
}

.address-row {
  @include media-breakpoint-down(md) {
    flex-wrap: wrap;
  }
}

.responsability {
  /deep/ iframe {
    width: 100%;
  }
}

.btn-subscription{
  background: #3D3D3D;
  border-radius: 18px;
  padding: 12px 66px;
  color: #fff;
  font-size: 18px;
  font-weight: 500;
  line-height: 25px;
  letter-spacing: 0em;
  text-align: center;
  border: none;
  text-decoration: none;
  &:hover{
    background: theme-color-level("blue-ml", 1)
  }
}

.vem-pro-inbrands{
  margin-bottom: 50px;

  h6{

    font-size: 24px;
    font-weight: 700;
    line-height: 40px;
    letter-spacing: 0em;
    text-align: left;

    @media (max-width: 600px){
      font-size: 20px;
      line-height: 1.6;
    }
  }

  p{

    font-size: 24px;
    font-weight: 400;
    line-height: 40px;
    letter-spacing: 0em;
    text-align: left;

    @media (max-width: 600px){
      font-size: 20px;
      line-height: 1.6;
    }
  }
}

.opportunity-description-title{
  font-size: 36px;
  font-weight: 800;
  line-height: 40px;
  letter-spacing: 0em;
  text-align: left;
  color: #3D3D3D;
  margin-bottom: 50px;

  @media (max-width: 600px){
    font-size: 28px;
  }
}

.opportunity-description-text{
  font-size: 24px;
  font-weight: 400;
  line-height: 40px;
  letter-spacing: 0em;
  text-align: left;
  color: #000000;

  @media (max-width: 600px){
    font-size: 20px;
    line-height: 1.6;
  }

  /deep/ ul{
    margin-left: 25px;
    li{
      list-style: unset;
    }
  }
}

.boxes-beneficios{
  display: flex;
  flex-wrap: wrap;

  @media (max-width: 980px){
    flex-wrap: nowrap;
    overflow: auto;
    margin: 0 -30px 0 -30px;
    max-width: none;
  }

  .box{
    width: 23%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin: 0 1% 50px 1%;

    @media (max-width: 980px){
      width: 150px;
      flex-shrink: 0;
    }

    p{

      font-size: 18px;
      font-weight: 700;
      line-height: 28px;
      letter-spacing: 0em;
      text-align: center;
      color: #000000;
      margin: 25px 0 0 0;
    }
  }
}

.final-text{
  p{

    font-size: 24px;
    font-weight: 700;
    line-height: 40px;
    letter-spacing: 0em;
    text-align: left;

    @media (max-width: 600px){
      font-size: 20px;
      line-height: 1.6;
    }
  }
}

/deep/li{
    list-style: disc;
  }
</style>